export default function Techniques() {
  const techniques = [
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Cupping Therapy (Hijama)',
      description: 'Promotes natural healing and detoxification through traditional therapeutic cupping methods.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Manual Therapy',
      description: 'Hands-on joint and muscle repair using soft tissue mobilization techniques.',
    },
    {
      icon: 'ri-walk-line',
      title: 'Movement &amp; Exercise Therapy',
      description: 'Personalized functional training programs designed to restore optimal movement patterns.',
    },
    {
      icon: 'ri-first-aid-kit-line',
      title: 'Kinesio Taping',
      description: 'Supporting joints and muscles during recovery with therapeutic elastic taping.',
    },
    {
      icon: 'ri-pulse-line',
      title: 'Normatec Compression',
      description: 'Dynamic pulsing compression therapy to speed up muscle recovery and reduce soreness.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electrotherapy &amp; Laser',
      description: 'Advanced technology for deep tissue healing and pain relief using therapeutic modalities.',
    },
  ];

  return (
    <section id="techniques" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B4F6C] mb-4">
            Our Advanced Techniques
          </h2>
          <div className="w-20 h-1 bg-[#14B8A6] mx-auto mb-4"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Combining traditional wisdom with modern technology for optimal healing outcomes
          </p>
        </div>

        {/* Featured Cupping Therapy Section */}
        <div className="mb-16 bg-gradient-to-br from-[#F0F9FF] to-white rounded-2xl overflow-hidden shadow-xl">
          <div className="grid lg:grid-cols-2 gap-0">
            <div className="relative h-80 lg:h-auto">
              <img
                src="https://static.readdy.ai/image/d4c6fcf69c7d885228da6e53459f8742/33111995be07e720aad02c7750c3144e.jpeg"
                alt="Cupping Therapy Treatment"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0B4F6C]/20 to-transparent"></div>
            </div>
            <div className="p-8 sm:p-12 flex flex-col justify-center">
              <div className="w-16 h-16 bg-[#14B8A6]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-contrast-drop-2-line text-3xl text-[#14B8A6]"></i>
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-[#0B4F6C] mb-4">
                Cupping Therapy (Hijama)
              </h3>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Experience the ancient healing art of cupping therapy, a powerful technique that promotes natural healing and detoxification. Our specialized Hijama treatments help release muscle tension, improve blood circulation, and accelerate recovery.
              </p>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-xl text-[#14B8A6] mt-0.5"></i>
                  <p className="text-sm text-gray-700">Relieves chronic pain and muscle tension</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-xl text-[#14B8A6] mt-0.5"></i>
                  <p className="text-sm text-gray-700">Enhances blood circulation and detoxification</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-xl text-[#14B8A6] mt-0.5"></i>
                  <p className="text-sm text-gray-700">Reduces inflammation and promotes healing</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-xl text-[#14B8A6] mt-0.5"></i>
                  <p className="text-sm text-gray-700">Effective for shoulder, back, and joint pain</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {techniques.map((technique, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-br from-[#F0F9FF] to-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 group cursor-pointer border border-[#14B8A6]/10"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-[#14B8A6]/5 rounded-bl-full -z-0"></div>
              <div className="relative z-10">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-5 shadow-md group-hover:scale-110 transition-transform">
                  <i className={`${technique.icon} text-3xl text-[#14B8A6]`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#0B4F6C] mb-3 group-hover:text-[#14B8A6] transition-colors">
                  {technique.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {technique.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#0B4F6C] to-[#14B8A6] rounded-2xl p-8 sm:p-12 text-center text-white">
          <h3 className="text-2xl sm:text-3xl font-bold mb-4">
            Experience the Difference
          </h3>
          <p className="text-base text-white/90 mb-8 max-w-2xl mx-auto">
            Our evidence-based techniques are carefully selected and applied by certified professionals to ensure the best possible outcomes for your recovery journey.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-[#0B4F6C] px-8 py-3 rounded-full text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap"
          >
            Schedule Your Session
          </button>
        </div>
      </div>
    </section>
  );
}